export default __webpack_public_path__ + "static/media/icon-laptop.00f7c106.svg";